import { MRT_ColumnDef, MRT_Row } from "material-react-table";
import { useMemo } from "react";
import { DocumentStruct } from "../../../common/Interfaces";
import DocumentAction from "./DocumentAction";
import { IColumnsProps } from "./DocumentTableInterfaces";
import PlusModel from "./PlusModel";
import AdvancedUserUpload from "./AdvancedUserUpload";

export default function DocumentColumns({
  isAdvancedUser,
  setPopupContent,
  setShowPopup,
  setPopupTitle,
  exclude,
  noAction,
}: IColumnsProps): MRT_ColumnDef<DocumentStruct>[] {
  return useMemo<MRT_ColumnDef<DocumentStruct>[]>(() => {
    const columns: MRT_ColumnDef<DocumentStruct>[] = [];
    const hide: boolean = process.env.REACT_APP_HIDE === "true";
    const isDeleteHidden: boolean = process.env.REACT_APP_HIDE_DELETE === "true";


    if (!noAction) {
      columns.push(
        {
          id: "advancedUserUpload",
          header: " ",
          size: 25,
          enableColumnActions: false,
          enableResizing: false,
          Cell: ({ row }: { row: MRT_Row<DocumentStruct> }) => (
            <AdvancedUserUpload document={row.original} />
          ),
        },
        {
          id: "actions",
          header: "Actions",
          size: isAdvancedUser ? (isDeleteHidden ? 130 : 160) : 130,
          enableColumnActions: false,
          enableResizing: false,
          Cell: ({ row }: { row: MRT_Row<DocumentStruct> }) => (
            <DocumentAction
              row={row.original}
              isAdvancedUser={isAdvancedUser}
            />
          ),
        }
      );
    }

    columns.push({
      accessorKey: "productCompany",
      header: "Product Company",
      size: 80,
      muiTableHeadCellProps: {
        sx: {
          fontSize: "13px",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          fontSize: "13px",
        },
      },
    });
    if (!hide) {
      columns.push({
        accessorKey: "productRange",
        header: "Product Range",
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      });
    }
    columns.push(
      {
        accessorFn: (row) => row.models?.[0]?.code || "",
        header: "Model",
        size: 130,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        Cell: ({ row }: { row: MRT_Row<DocumentStruct> }) => (
          <PlusModel
            row={row.original}
            setPopupContent={setPopupContent}
            setShowPopup={setShowPopup}
            setPopupTitle={setPopupTitle}
          />
        ),
      }
      // {
      //   accessorFn: (row) => (row.productNumbers ? [0] : ""),
      //   header: "Product Number",
      //   size: 120,
      //   muiTableHeadCellProps: {
      //     sx: {
      //       fontSize: "13px",
      //     },
      //   },
      //   muiTableBodyCellProps: {
      //     sx: {
      //       fontSize: "13px",
      //     },
      //   },
      //   Cell: ({ row }: { row: MRT_Row<DocumentStruct> }) => (
      //     <PlusProductNumber
      //       row={row.original}
      //       setPopupContent={setPopupContent}
      //       setShowPopup={setShowPopup}
      //       setPopupTitle={setPopupTitle}
      //     />
      //   ),
      // },
    );
    if (!exclude) {
      columns.push({
        accessorKey: "serialNumber",
        header: "Serial Number",
        size: 130,

        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      });
    }
    columns.push(
      {
        accessorKey: "documentType.type",
        header: "Type",
        size: 150,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      },
      {
        accessorKey: "documentType.description",
        header: "Description",
        size: 150,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      },
      {
        accessorKey: "startDate",
        header: "Start Date",
        size: 90,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      },
      {
        accessorKey: "endDate",
        header: "End Date",
        size: 90,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      },
      {
        accessorKey: "file",
        header: "File name / URL ",
        size: 330,
        grow: true,
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
        },
        Cell: ({ row }: { row: MRT_Row<DocumentStruct> }) => {
          const file = row.original.file;
          return file && row.original.linkType == "Url" ? (
            <a
              className="pointer"
              href={file}
              target="_blank"
              rel="noopener noreferrer"
            >
              {file}
            </a>
          ) : (
            <a
              className="clickable-cell"
              href={row.original.sasToken ?? ""}
              target="_blank"
              rel="noopener noreferrer"
            >
              {file}
            </a>
          );
        },
      },
      {
        accessorKey: "uploadDate",
        header: "Upload Date",
        size: 90,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
        muiTableBodyCellProps: {
          sx: {
            fontSize: "13px",
          },
        },
      }
    );

    return columns;
  }, [exclude, isAdvancedUser]);
}
